import { applyActionCode, confirmPasswordReset } from "firebase/auth";

import { AuthAPI } from "../infrastructure/api/auth.api";
import { auth } from "../infrastructure/firebase";

/** Send the password reset link. */
export async function sendPasswordResetEmail(email: string): Promise<void> {
    await AuthAPI.sendPasswordResetEmail(email);
}

/** Apply an emailed action code (email verification or recovery). */
export async function applyEmailActionCode(oobCode: string): Promise<void> {
    await applyActionCode(auth, oobCode);
}

/** Set a new password with the code from the reset email. */
export async function confirmNewPassword(oobCode: string, newPassword: string): Promise<void> {
    await confirmPasswordReset(auth, oobCode, newPassword);
}
